import { render, staticRenderFns } from "./ActionCenter.vue?vue&type=template&id=209e1013&scoped=true"
import script from "./ActionCenter.vue?vue&type=script&lang=js"
export * from "./ActionCenter.vue?vue&type=script&lang=js"
import style0 from "./ActionCenter.vue?vue&type=style&index=0&id=209e1013&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209e1013",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('209e1013')) {
      api.createRecord('209e1013', component.options)
    } else {
      api.reload('209e1013', component.options)
    }
    module.hot.accept("./ActionCenter.vue?vue&type=template&id=209e1013&scoped=true", function () {
      api.rerender('209e1013', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/costManagement/costsFee/cmp/ActionCenter.vue"
export default component.exports